import { Chip } from "@mui/material"
import { AccessTime, CheckCircle, Warning, HelpOutline } from "@mui/icons-material"
import styles from "./DisciplinaryStatusBadge.module.css"

interface DisciplinaryStatusBadgeProps {
  status: string
}

export default function DisciplinaryStatusBadge({ status }: DisciplinaryStatusBadgeProps) {
  switch (status) {
    case "query_issued":
      return (
        <Chip
          icon={<AccessTime className={styles.iconSmall} />}
          label="Query Issued"
          size="small"
          className={`${styles.statusChip} ${styles.queryIssued}`}
        />
      )
    case "response_submitted":
      return (
        <Chip
          icon={<CheckCircle className={styles.iconSmall} />}
          label="Response Submitted"
          size="small"
          className={`${styles.statusChip} ${styles.responseSubmitted}`}
        />
      )
    case "penalty_applied":
      return (
        <Chip
          icon={<Warning className={styles.iconSmall} />}
          label="Penalty Applied"
          size="small"
          className={`${styles.statusChip} ${styles.penaltyApplied}`}
        />
      )
    case "closed":
      return (
        <Chip
          icon={<CheckCircle className={styles.iconSmall} />}
          label="Closed"
          size="small"
          className={`${styles.statusChip} ${styles.closed}`}
        />
      )
    case "warning_issued":
      return (
        <Chip
          icon={<Warning className={styles.iconSmall} />}
          label="Warning Issued"
          size="small"
          className={`${styles.statusChip} ${styles.warningIssued}`}
        />
      )
    default:
      return (
        <Chip
          icon={<HelpOutline className={styles.iconSmall} />}
          label={status || "Unknown"}
          size="small"
          className={`${styles.statusChip} ${styles.unknown}`}
        />
      )
  }
}
